module.exports = __webpack_public_path__ + "static/media/kv-esg.5e0cd5c9.png";